import styled from 'styled-components';
import { colors } from 'spw-theme';

export const EmptyListBox = styled.div`
  && {
    color: ${colors.mainGray};
    font-weight: normal;
    font-size: 14px;
  }
`;

export const EmptyListBoxWrapper = styled.div`
  && {
    height: 68px;
    padding-top: 8px;
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const CardLegend = styled.p`
  margin-top: 16px;
  margin-bottom: 0px;
  font-size: 12px;
`;
